/* cold-master.js - Cold Standard premium interactions */

function csInitBorders() {
  var btns = document.querySelectorAll('.hero .button-secondary');
  btns.forEach(function (btn) {
    if (btn.className.indexOf('button_cs_top_1') !== -1) return;
    if (btn.querySelector('.cs-border')) return;
    ['t','r','b','l'].forEach(function (side) {
      var el = document.createElement('span');
      el.className = 'cs-border cs-border--' + side;
      btn.appendChild(el);
    });
  });
}

function csInitHeadingReveal() {
  document.querySelectorAll('.hero').forEach(function (hero) {
    var existing = hero.querySelector('[data-cs-revealed]');
    if (existing) existing.removeAttribute('data-cs-revealed');
    var heading = hero.querySelector('h1') || hero.querySelector('h2') || hero.querySelector('h3');
    if (!heading) return;
    if (heading.querySelector('.cs-word-clip')) {
      var ws = [];
      heading.querySelectorAll('.cs-word-inner').forEach(function (el) { ws.push(el.textContent); });
      heading.textContent = ws.join(' ');
    }
    heading.setAttribute('data-cs-revealed', '1');
    var originalText = heading.textContent.trim();
    if (!originalText) return;
    var words = originalText.split(/\s+/);
    heading.textContent = '';
    words.forEach(function (word, i) {
      var clip = document.createElement('span'); clip.className = 'cs-word-clip';
      var inner = document.createElement('span'); inner.className = 'cs-word-inner';
      inner.textContent = word; inner.style.animationDelay = (0.25 + i * 0.13) + 's';
      clip.appendChild(inner); heading.appendChild(clip);
      if (i < words.length - 1) heading.appendChild(document.createTextNode(' '));
    });
  });
}

function csInitHero2Button() {
  var btn = document.querySelector('[class*="button_cs_top_1"]');
  if (!btn) return;
  var oldSvg = btn.querySelector('.cs-btn-draw-svg');
  if (oldSvg) oldSvg.remove();
  btn.classList.remove('cs-h2-ready'); btn.classList.remove('cs-h2-sheen');
  requestAnimationFrame(function () {
    var r = btn.getBoundingClientRect();
    var W = Math.round(r.width); var H = Math.round(r.height);
    if (W < 10) { setTimeout(csInitHero2Button, 150); return; }
    var ns = 'http://www.w3.org/2000/svg'; var inset = 1;
    var rW = W - inset * 2; var rH = H - inset * 2;
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'cs-btn-draw-svg'); svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('width', W); svg.setAttribute('height', H);
    var defs = document.createElementNS(ns, 'defs'); var flt = document.createElementNS(ns, 'filter');
    flt.id = 'cs-h2-glow'; flt.setAttribute('x', '-300%'); flt.setAttribute('y', '-300%');
    flt.setAttribute('width', '700%'); flt.setAttribute('height', '700%');
    [['2','b1'],['5','b2'],['12','b3']].forEach(function (p) {
      var b = document.createElementNS(ns, 'feGaussianBlur');
      b.setAttribute('in', 'SourceGraphic'); b.setAttribute('stdDeviation', p[0]); b.setAttribute('result', p[1]);
      flt.appendChild(b);
    });
    var mg = document.createElementNS(ns, 'feMerge');
    ['b3','b2','b1','SourceGraphic'].forEach(function (i) { var mn = document.createElementNS(ns, 'feMergeNode'); mn.setAttribute('in', i); mg.appendChild(mn); });
    flt.appendChild(mg); defs.appendChild(flt); svg.appendChild(defs);
    var pathD = 'M '+inset+' '+inset+' L '+(inset+rW)+' '+inset+' L '+(inset+rW)+' '+(inset+rH)+' L '+inset+' '+(inset+rH)+' Z';
    var borderPath = document.createElementNS(ns, 'path');
    borderPath.setAttribute('d', pathD); borderPath.setAttribute('fill', 'none');
    borderPath.setAttribute('stroke', 'none'); borderPath.setAttribute('stroke-width', '1.5');
    borderPath.setAttribute('stroke-linecap', 'butt'); svg.appendChild(borderPath);
    var halo = document.createElementNS(ns, 'circle');
    halo.setAttribute('r', '10'); halo.setAttribute('fill', 'rgba(255,255,255,0.07)');
    halo.setAttribute('cx', inset); halo.setAttribute('cy', inset); halo.style.opacity = '0'; svg.appendChild(halo);
    var dot = document.createElementNS(ns, 'circle');
    dot.setAttribute('r', '3'); dot.setAttribute('fill', '#ffffff'); dot.setAttribute('filter', 'url(#cs-h2-glow)');
    dot.setAttribute('cx', inset); dot.setAttribute('cy', inset); dot.style.opacity = '0'; svg.appendChild(dot);
    btn.appendChild(svg);
    var perim = borderPath.getTotalLength ? borderPath.getTotalLength() : 2 * (rW + rH);
    var gap = perim * 2 + 10;
    var topF = rW/perim; var rgtF = rH/perim; var botF = rW/perim; var lftF = rH/perim;
    var corners = [0, topF, topF+rgtF, topF+rgtF+botF, 1];
    function getPos(t) {
      if (t <= topF) { return [inset + (t/topF)*rW, inset]; }
      else if (t <= topF+rgtF) { var f=(t-topF)/rgtF; return [inset+rW, inset+f*rH]; }
      else if (t <= topF+rgtF+botF) { var f=(t-topF-rgtF)/botF; return [inset+rW-f*rW, inset+rH]; }
      else { var f=lftF>0?(t-topF-rgtF-botF)/lftF:1; return [inset, inset+rH-f*rH]; }
    }
    function premiumEase(t) {
      var base = t<0.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2;
      return Math.min(1, Math.max(0, base + 0.018*Math.sin(t*Math.PI*6)));
    }
    function cornerProximity(t) {
      var minDist=1;
      for (var i=0;i<corners.length;i++) { var d=Math.abs(t-corners[i]); if(d<minDist) minDist=d; }
      return Math.max(0, 1-minDist/0.045);
    }
    var DELAY=400; var DURATION=1300; var pageTs=performance.now(); var startTs=null; var textDone=false;
    function frame(now) {
      var elapsed=now-pageTs;
      if (elapsed<DELAY) { requestAnimationFrame(frame); return; }
      if (!startTs) {
        startTs=now;
        borderPath.setAttribute('stroke','rgba(255,255,255,0.88)');
        borderPath.setAttribute('stroke-dasharray','0 '+gap);
        borderPath.setAttribute('stroke-dashoffset','0');
        dot.style.opacity='1'; halo.style.opacity='1';
      }
      var raw=Math.min((now-startTs)/DURATION,1); var t=premiumEase(raw);
      var pos=getPos(t); dot.setAttribute('cx',pos[0]); dot.setAttribute('cy',pos[1]);
      halo.setAttribute('cx',pos[0]); halo.setAttribute('cy',pos[1]);
      var cp=cornerProximity(raw); var pulse=Math.sin(raw*Math.PI*14)*0.5+0.5;
      halo.setAttribute('r',(9+cp*9+pulse*3).toFixed(1));
      halo.style.opacity=(0.06+cp*0.28+pulse*0.05).toFixed(3);
      borderPath.setAttribute('stroke-dasharray',(t*perim)+' '+gap);
      if (!textDone && t>=0.6) { textDone=true; btn.classList.add('cs-h2-ready'); }
      if (raw<1) {
        requestAnimationFrame(frame);
      } else {
        dot.style.transition='opacity 0.2s ease'; dot.style.opacity='0';
        halo.style.transition='opacity 0.2s ease'; halo.style.opacity='0';
        if (!textDone) btn.classList.add('cs-h2-ready');
        setTimeout(function() { btn.classList.add('cs-h2-sheen'); setTimeout(function() { btn.classList.remove('cs-h2-sheen'); }, 750); }, 220);
      }
    }
    requestAnimationFrame(frame);
  });
}

/* ==================
   Tabele velicina
   ================== */
var CS_SG_MUSKE = [
  ['26.0','41','8'],['26.5','42','8.5'],['27.0','42.5','9'],
  ['27.5','43','9.5'],['28.0','44','10'],['28.5','44.5','10.5'],
  ['29.0','45','11'],['29.5','45.5','11.5'],['30.0','46','12']
];
var CS_SG_ZENSKE = [
  ['21.5','35','4.5'],['22.0','36','5'],['22.5','36.5','5.5'],
  ['23.0','37','6'],['23.5','37.5','6.5'],['24.0','38','7'],
  ['24.5','38.5','7.5'],['25.0','39','8'],['25.5','40','8.5'],
  ['26.0','40.5','9'],['26.5','41','9.5'],['27.0','42','10']
];
var CS_SG_TABLE = [
  ['22.0','36','5'],['22.5','36.5','5.5'],['23.0','37','6'],
  ['23.5','37.5','6.5'],['24.0','38','7'],['24.5','38.5','7.5'],
  ['25.0','39','8'],['25.5','40','8.5'],['26.0','40.5','9'],
  ['26.5','41','9.5'],['27.0','42','10'],['27.5','42.5','10.5'],
  ['28.0','43','11'],['28.5','44','11.5'],['29.0','44.5','12'],
  ['29.5','45','12.5'],['30.0','46','13']
];

function csGetSizeTable() {
  var gender = '';
  var el = document.querySelector('[data-cs-gender]');
  if (el) gender = el.getAttribute('data-cs-gender') || '';
  if (!gender) gender = window.CS_PRODUCT_GENDER || '';
  gender = gender.trim() || 'universal';
  if (gender === 'musko')  return { rows: CS_SG_MUSKE,  label: 'Muške veličine' };
  if (gender === 'zensko') return { rows: CS_SG_ZENSKE, label: 'Ženske veličine' };
  return { rows: CS_SG_TABLE, label: 'Vodič za veličine' };
}

/* ==================
   Size Guide Modal
   ================== */
function csInitSizeGuideModal() {
  if (document.getElementById('cs-sg-overlay')) return;
  var overlay = document.createElement('div');
  overlay.id = 'cs-sg-overlay';
  overlay.className = 'cs-sg-overlay';
  overlay.innerHTML =
    '<div class="cs-sg-backdrop"></div>'
    +'<div class="cs-sg-modal" role="dialog" aria-modal="true" aria-labelledby="cs-sg-title-el">'
    +'<span class="cs-sg-handle"></span>'
    +'<div class="cs-sg-header">'
    +'<p class="cs-sg-title" id="cs-sg-title-el">Vodič za veličine</p>'
    +'<button class="cs-sg-close" aria-label="Zatvori"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#444" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>'
    +'</div>'
    +'<p class="cs-sg-note">Izmeri stopalo od pete do vrha i uporedi sa tabelom.</p>'
    +'<div id="cs-sg-table-wrap"></div>'
    +'</div>';
  document.body.appendChild(overlay);
  var closeBtn = overlay.querySelector('.cs-sg-close');
  var backdrop = overlay.querySelector('.cs-sg-backdrop');
  var titleEl = document.getElementById('cs-sg-title-el');
  var tableWrap = document.getElementById('cs-sg-table-wrap');
  function buildTable() {
    var td = csGetSizeTable();
    if (titleEl) titleEl.textContent = td.label;
    if (tableWrap) {
      tableWrap.innerHTML = '<table class="cs-sg-table"><thead><tr><th>CM</th><th>EU</th><th>US</th></tr></thead><tbody>'
        + td.rows.map(function(r){ return '<tr><td>'+r[0]+' cm</td><td>'+r[1]+'</td><td>'+r[2]+'</td></tr>'; }).join('')
        + '</tbody></table>';
    }
  }
  function openModal() { buildTable(); overlay.classList.add('cs-sg-open'); document.body.style.overflow='hidden'; setTimeout(function(){ closeBtn.focus(); },50); }
  function closeModal() { overlay.classList.remove('cs-sg-open'); document.body.style.overflow=''; }
  backdrop.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(e){ if((e.key==='Escape'||e.keyCode===27)&&overlay.classList.contains('cs-sg-open')) closeModal(); });
  document.addEventListener('click', function(e){
    var link = e.target.closest ? e.target.closest('.cs-size-guide') : null;
    if (!link && e.target.classList && e.target.classList.contains('cs-size-guide')) link = e.target;
    if (link) { e.preventDefault(); openModal(); }
  });
}

/* ==================
   Freeze media gallery
   ================== */
function csFreezeMediaGallery() {
  var NOOP = function() {};
  function patchGallery() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return false;
    if (gallery._csFrozen) return true;
    gallery.replaceWith = NOOP;
    gallery._csFrozen = true;
    return true;
  }
  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    var ok = patchGallery();
    if (ok || attempts > 40) clearInterval(interval);
  }, 150);
}

/* ==================
   Size Picker - Ring Pulse
   ================== */
function csInitSizePulse() {
  var fieldset = document.querySelector('fieldset.variant-option');
  if (!fieldset || fieldset._csPulseInited) return;
  fieldset._csPulseInited = true;
  fieldset.addEventListener('change', function(e) {
    if (e.target.type !== 'radio') return;
    var selectedLabel = e.target.closest ? e.target.closest('label') : null;
    if (!selectedLabel) fieldset.querySelectorAll('label').forEach(function(l){ if(l.contains(e.target)) selectedLabel=l; });
    if (!selectedLabel) return;
    fieldset.querySelectorAll('.cs-sz-pulse').forEach(function(el){el.classList.remove('cs-sz-pulse');});
    void selectedLabel.offsetWidth;
    selectedLabel.classList.add('cs-sz-pulse');
    setTimeout(function(){selectedLabel.classList.remove('cs-sz-pulse');}, 520);
  });
}

/* ==================
   Size Picker - Legend sa premium chip linkom
   ================== */
var CS_RULER_SVG = '<svg class="cs-sg-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
  + '<path d="M21.3 8.7 8.7 21.3c-1 1-2.5 1-3.4 0l-2.6-2.6c-1-1-1-2.5 0-3.4L15.3 2.7c1-1 2.5-1 3.4 0l2.6 2.6c1 1 1 2.5 0 3.4Z"/>'
  + '<path d="m7.5 10.5 2 2"/>'
  + '<path d="m10.5 7.5 2 2"/>'
  + '<path d="m13.5 4.5 2 2"/>'
  + '<path d="m4.5 13.5 2 2"/>'
  + '</svg>';

var _csInjecting = false;

function tryInitLegend() {
  var fieldset = document.querySelector('fieldset.variant-option');
  if (!fieldset) return false;
  var legend = fieldset.querySelector('legend');
  if (!legend) return false;
  if (legend.querySelector('.cs-size-guide')) return true;
  _csInjecting = true;
  legend.innerHTML =
    '<span class="cs-legend-label">Odaberi veličinu</span>'
    + '<a class="cs-size-guide" href="#" role="button" aria-label="Otvori vodič za veličine">'
    + CS_RULER_SVG
    + '<span>Vodič za veličine</span>'
    + '</a>';
  _csInjecting = false;
  csInitSizePulse();
  return true;
}

function csWatchLegend() {
  if (window._csLegendWatcher) return;
  window._csLegendWatcher = true;

  new MutationObserver(function() {
    if (_csInjecting) return;
    var legend = document.querySelector('fieldset.variant-option legend');
    if (legend && !legend.querySelector('.cs-size-guide')) {
      tryInitLegend();
    }
  }).observe(document.body, { childList: true, subtree: true });
}

function csInitSizePicker() {
  if (tryInitLegend()) {
    csWatchLegend();
    return;
  }
  var attempts = 0;
  var interval = setInterval(function() {
    attempts++;
    if (tryInitLegend() || attempts > 53) {
      clearInterval(interval);
      csWatchLegend();
    }
  }, 150);
}

/* ==================
   ATC - Loading & Success States
   ================== */
function csInitATCStates() {
  var atcBtn = document.querySelector('button[data-testid="standalone-add-to-cart"]');
  if (!atcBtn || atcBtn._csAtcInited) return;
  atcBtn._csAtcInited = true;
  atcBtn.addEventListener('click', function() {
    if (atcBtn.classList.contains('cs-atc-loading')) return;
    atcBtn.classList.add('cs-atc-loading');
    var resolved = false;
    var textSpan = atcBtn.querySelector('.add-to-cart-text');
    var originalHTML = textSpan ? textSpan.innerHTML : '';
    function resolve(success) {
      if (resolved) return; resolved = true;
      atcBtn.classList.remove('cs-atc-loading');
      if (success && textSpan) {
        atcBtn.classList.add('cs-atc-success');
        textSpan.innerHTML = '<span style="position:relative;z-index:1;display:inline-flex;align-items:center;gap:8px"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Dodato u korpu</span>';
        setTimeout(function(){ atcBtn.classList.remove('cs-atc-success'); if(textSpan) textSpan.innerHTML=originalHTML; }, 2200);
      }
    }
    var cartBadge = document.querySelector('[class*="cart-count"]') || document.querySelector('[aria-label*="cart"]');
    var beforeCount = cartBadge ? cartBadge.textContent.trim() : '';
    var obs = new MutationObserver(function(){
      var afterCount = cartBadge ? cartBadge.textContent.trim() : '';
      if (afterCount !== beforeCount || document.querySelector('.cart-drawer[open]')) { obs.disconnect(); setTimeout(function(){resolve(true);},150); }
    });
    obs.observe(document.body, {childList:true, subtree:true, characterData:true});
    setTimeout(function(){obs.disconnect(); resolve(false);}, 5000);
  });
}

/* ==================
   Trust Strip
   ================== */
function csInjectTrustStripInline() {
  if (document.querySelector('.cs-trust-strip-inline')) return;
  var atcBtn = document.querySelector('button[data-testid="standalone-add-to-cart"]');
  if (!atcBtn) return;
  var strip = document.createElement('div');
  strip.className = 'cs-trust-strip-inline';
  strip.innerHTML =
    '<span class="cs-tsi__item"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>Sigurna kupovina</span>'
    +'<span class="cs-tsi__sep">·</span>'
    +'<span class="cs-tsi__item"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 1 0 .49-3.5"/></svg>Besplatna zamena</span>';
  var productForm = document.querySelector('product-form') || atcBtn.parentElement;
  productForm.insertAdjacentElement('afterend', strip);
}

/* ==================
   Legend CSS — premium pill chip
   ================== */
function csInjectLegendStyles() {
  if (document.getElementById('cs-legend-style')) return;
  var s = document.createElement('style'); s.id = 'cs-legend-style';
  s.textContent = [
    'fieldset.variant-option legend{display:flex !important;justify-content:space-between !important;align-items:center !important;width:100% !important;padding-bottom:12px !important;}',
    '.cs-legend-label{font-size:11px !important;font-weight:600 !important;letter-spacing:0.08em !important;text-transform:uppercase !important;color:#999 !important;}',
    '.cs-size-guide{display:inline-flex !important;align-items:center !important;gap:5px !important;padding:6px 11px !important;border-radius:100px !important;border:1.5px solid #d8d8d8 !important;background:#f7f7f7 !important;color:#555 !important;font-size:9px !important;font-weight:700 !important;letter-spacing:0.10em !important;text-transform:uppercase !important;text-decoration:none !important;cursor:pointer !important;white-space:nowrap !important;-webkit-tap-highlight-color:transparent !important;user-select:none !important;transition:border-color 180ms ease,background 180ms ease,color 180ms ease,transform 220ms cubic-bezier(0.34,1.5,0.64,1),box-shadow 180ms ease !important;}',
    '.cs-sg-icon{flex-shrink:0 !important;transition:transform 220ms cubic-bezier(0.34,1.5,0.64,1) !important;}',
    '.cs-size-guide:hover{border-color:#aaa !important;background:#efefef !important;color:#111 !important;transform:translateY(-2px) !important;box-shadow:0 3px 10px rgba(0,0,0,0.09) !important;}',
    '.cs-size-guide:hover .cs-sg-icon{transform:rotate(-12deg) scale(1.1) !important;}',
    '.cs-size-guide:active{transform:scale(0.94) !important;transition-duration:70ms !important;box-shadow:none !important;}'
  ].join('');
  document.head.appendChild(s);
}

/* ==================
   CUSTOM STICKY ATC
   ================== */
function csInitStickyATC() {
  var old = document.getElementById('cs-sticky-atc');
  if (old) old.remove();
  var mainBtn = document.querySelector('button[data-testid="standalone-add-to-cart"]');
  if (!mainBtn) return;
  var titleEl = document.querySelector('.product-information h1, .product h1, h1');
  var productTitle = titleEl ? titleEl.textContent.trim() : '';
  var imgEl = document.querySelector('.product__media img, media-gallery img, .product-media-gallery img, .product img');
  var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';
  if (imgEl && imgEl.srcset) {
    var parts = imgEl.srcset.split(',');
    if (parts.length) { var small = parts[0].trim().split(' ')[0]; if (small) imgSrc = small; }
  }
  function getPrice() {
    var el = document.querySelector('.price-item--sale') || document.querySelector('.price-item--regular');
    return el ? el.textContent.trim() : '';
  }
  function getSelectedSize() {
    var checked = document.querySelector('fieldset.variant-option input[type="radio"]:checked');
    return checked ? 'Broj ' + checked.value : null;
  }
  var bar = document.createElement('div');
  bar.id = 'cs-sticky-atc'; bar.className = 'cs-sticky-atc';
  var selectedSize = getSelectedSize();
  var sizeHTML = selectedSize
    ? '<span class="cs-satc__size-val">' + selectedSize + '</span>'
    : '<span class="cs-satc__size-hint">Odaberi veličinu</span>';
  bar.innerHTML =
    '<div class="cs-satc__inner">'
    +'<div class="cs-satc__info">'
    +(imgSrc ? '<img class="cs-satc__thumb" src="'+imgSrc+'" alt="" loading="eager">' : '<div class="cs-satc__thumb cs-satc__thumb--empty"></div>')
    +'<div class="cs-satc__text">'
    +'<span class="cs-satc__title">'+productTitle+'</span>'
    +'<span class="cs-satc__size" id="cs-satc-size">'+sizeHTML+'</span>'
    +'</div></div>'
    +'<div class="cs-satc__right">'
    +'<span class="cs-satc__price" id="cs-satc-price">'+getPrice()+'</span>'
    +'<button class="cs-satc__btn" id="cs-satc-btn">Dodaj u korpu</button>'
    +'</div></div>';
  document.body.appendChild(bar);
  if (!document.getElementById('cs-satc-sheen-style')) {
    var ss = document.createElement('style'); ss.id = 'cs-satc-sheen-style';
    ss.textContent =
      '@keyframes cs-satc-gleam{0%{transform:translateX(-140%) skewX(-18deg);opacity:0}12%{opacity:1}88%{opacity:1}100%{transform:translateX(340%) skewX(-18deg);opacity:0}}'
      +'.cs-satc__btn::after{content:"";position:absolute;top:-8%;left:0;width:38%;height:116%;background:linear-gradient(90deg,transparent 0%,rgba(255,255,255,0.22) 50%,transparent 100%);transform:translateX(-140%) skewX(-18deg);pointer-events:none;z-index:3;opacity:0;border-radius:inherit;}'
      +'.cs-satc__btn.cs-satc-gleam::after{animation:cs-satc-gleam 0.7s cubic-bezier(0.4,0,0.2,1) forwards}';
    document.head.appendChild(ss);
  }
  var sizeSpan = document.getElementById('cs-satc-size');
  var satcBtn = document.getElementById('cs-satc-btn');
  setTimeout(function startSheen() {
    var b = document.getElementById('cs-satc-btn'); if (!b) return;
    b.classList.remove('cs-satc-gleam'); void b.offsetWidth; b.classList.add('cs-satc-gleam');
    setTimeout(function(){ var b2=document.getElementById('cs-satc-btn'); if(b2) b2.classList.remove('cs-satc-gleam'); }, 750);
    setTimeout(startSheen, 4000);
  }, 2500);
  document.addEventListener('change', function(e) {
    if (!e.target || e.target.type !== 'radio') return;
    var fs = e.target.closest ? e.target.closest('fieldset.variant-option') : null;
    if (!fs) return;
    if (sizeSpan) sizeSpan.innerHTML = '<span class="cs-satc__size-val">Broj ' + e.target.value + '</span>';
    bar.classList.remove('cs-satc--warn');
  });
  satcBtn.addEventListener('click', function() {
    var checked = document.querySelector('fieldset.variant-option input[type="radio"]:checked');
    if (!checked) {
      bar.classList.remove('cs-satc--warn'); void bar.offsetWidth; bar.classList.add('cs-satc--warn');
      if (sizeSpan) {
        sizeSpan.innerHTML = '<span class="cs-satc__size-hint cs-satc__size-hint--warn">Odaberi veličinu ↑</span>';
        setTimeout(function(){ sizeSpan.innerHTML='<span class="cs-satc__size-hint">Odaberi veličinu</span>'; bar.classList.remove('cs-satc--warn'); }, 1800);
      }
      var fieldset = document.querySelector('fieldset.variant-option');
      if (fieldset) fieldset.scrollIntoView({behavior:'smooth', block:'center'});
      return;
    }
    mainBtn.click();
  });
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { bar.classList.remove('cs-sticky-atc--visible'); }
        else if (entry.boundingClientRect.top < 0) { bar.classList.add('cs-sticky-atc--visible'); }
        else { bar.classList.remove('cs-sticky-atc--visible'); }
      });
    }, {threshold: 0});
    io.observe(mainBtn);
  }
}

/* ==================
   PARTNER UPSELL v2.3 — AJAX dodavanje + dismiss + partner par na dnu bez treperenja
   Ključevi partner stavki se pamte odmah pri dodavanju (sessionStorage),
   a premeshtanje reda se radi sinhrono u MutationObserver-u — pre iscrtavanja.
   ================== */
var _csPuKeys = [];
try { _csPuKeys = JSON.parse(sessionStorage.getItem('csPuKeys') || '[]') || []; } catch (e) { _csPuKeys = []; }
var _csReordering = false;

function csSavePuKeys() {
  try { sessionStorage.setItem('csPuKeys', JSON.stringify(_csPuKeys)); } catch (e) {}
}

function csReorderPartnerRowsSync() {
  if (!_csPuKeys.length) return;
  _csReordering = true;
  document.querySelectorAll('cart-items-component').forEach(function (comp) {
    _csPuKeys.forEach(function (key) {
      var row = comp.querySelector('.cart-items__table-row[data-key="' + key + '"]');
      if (row && row.parentElement && row.parentElement.lastElementChild !== row) {
        row.parentElement.appendChild(row);
      }
    });
  });
  _csReordering = false;
}

function csSeedPuKeys() {
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      if (!cart || !cart.items) return;
      _csPuKeys = [];
      cart.items.forEach(function (it) {
        if (it.properties && it.properties._cs_partner) _csPuKeys.push(it.key);
      });
      csSavePuKeys();
      csReorderPartnerRowsSync();
    })
    .catch(function () {});
}

function csInitPartnerUpsell() {
  if (window._csPuInited) return;
  window._csPuInited = true;

  try {
    if (sessionStorage.getItem('csPuOff') === '1') {
      document.documentElement.classList.add('cs-pu-hidden');
    }
  } catch (e) {}

  document.addEventListener('click', function (e) {
    var skip = e.target && e.target.closest ? e.target.closest('.cs-pu__skip') : null;
    if (!skip) return;
    try { sessionStorage.setItem('csPuOff', '1'); } catch (err) {}
    document.documentElement.classList.add('cs-pu-hidden');
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('cs-pu__form')) return;
    e.preventDefault();
    e.stopPropagation();
    var checked = form.querySelector('input[name="id"]:checked');
    if (!checked) return;
    var btn = form.querySelector('.cs-pu__btn');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Dodajem…'; }

    var fd = new FormData();
    fd.append('id', checked.value);
    fd.append('quantity', '1');
    fd.append('properties[_cs_partner]', '1');

    var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (resp.status && resp.status !== 200) { throw new Error(resp.message || 'error'); }
        if (resp.key && _csPuKeys.indexOf(resp.key) === -1) {
          _csPuKeys.push(resp.key);
          csSavePuKeys();
        }
        var evt = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: 'cs-partner-upsell',
            data: {
              source: 'cs-partner-upsell',
              itemCount: 1,
              variantId: String(checked.value)
            }
          }
        });
        document.dispatchEvent(evt);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
        window.location.href = '/cart';
      });
  }, true);

  new MutationObserver(function () {
    if (_csReordering) return;
    csReorderPartnerRowsSync();
  }).observe(document.body, { childList: true, subtree: true });

  csReorderPartnerRowsSync();
  csSeedPuKeys();
}

/* ==================
   Product Page Init
   ================== */
function csInitProductPage() {
  csInjectLegendStyles();
  csInitSizeGuideModal();
  csInitSizePicker();
  csFreezeMediaGallery();
  csInitATCStates();
  csInjectTrustStripInline();
  csInitStickyATC();
}

function csInit() {
  csInitBorders();
  csInitHeadingReveal();
  csInitHero2Button();
  csInitPartnerUpsell();
  if (window.location.pathname.indexOf('/products/') !== -1) {
    csInitProductPage();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', csInit);
} else {
  csInit();
}

document.addEventListener('shopify:section:load', function() {
  csInitBorders();
  csInitHeadingReveal();
  csInitHero2Button();
  if (window.location.pathname.indexOf('/products/') !== -1) {
    var fs = document.querySelector('fieldset.variant-option');
    if (fs) { delete fs._csLegendInited; delete fs._csPulseInited; }
    csInitProductPage();
  }
});
